module.exports = __webpack_public_path__ + "static/media/doc1.ff97aad3.mp4";